<template>
    <div class="search-result">
        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            @load="onLoad"
        >
            <form action="/">
                <van-search
                    placeholder="请输入您想找的宝贝"
                    show-action
                    shape="round"
                    v-model="searchData.productName"
                    @search="onSeach"
                >
                    <template slot="left">
                        <img src="~img/common/fanhui.png" class="van-search-back" alt="" @click="$router.back()">
                    </template>
                    <template slot="action">
                        <span class="van-search-action" @click="onSeach">搜索</span>
                    </template>
                </van-search>
            </form>
            <van-dropdown-menu active-color="#EB5435">
                <van-dropdown-item v-model="value1" :options="option1" @change="onSort($event, 1)" />
                <van-dropdown-item v-model="value2" :options="option2" @change="onSort($event, 2)" />
            </van-dropdown-menu>
            <view-body :list="goodsList"></view-body>
        </van-list>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ViewBody from './ViewBody';
export default {
    components: {
        ViewBody
    },
    data() {
        return {
            value1: '',
            value2: '',
            option1: [
                { text: '全部', value: '' },
                { text: '销量从高到低', value: '1' },
                { text: '销量从低到高', value: '2' }
            ],
            option2: [
                { text: '全部', value: '' },
                { text: '价格从高到低', value: '3' },
                { text: '价格从低到高', value: '4' }
            ],
            searchData: {
                productName: '',
                otherSort: '',
                page: 1,
                rows: 10
            },
            loading: false,
            finished: false
        };
    },
    computed: {
        ...mapState('goods', {
            goodsList: 'goodsList'
        })
    },
    methods: {
        ...mapActions('goods', {
            getGoodsList: 'getGoodsListAction'
        }),
        onSort(value, type) {
            this.searchData.otherSort = this[`value${type}`];
            this.searchData.page = 1;
            this.onLoad();
        },
        onSeach() {
            this.searchData.page = 1;
            this.onLoad();
        },
        onLoad() {
            this.loading = true;
            this.getGoodsList(this.searchData).then((res) => {
                this.searchData.page++;
                this.loading = false;
                if(res.length<10) {
                    this.finished = true;
                }
            });
        }
    },
    created() {
        this.searchData.productName = this.$route.query.params;
        this.searchData.businessProperty = this.$route.query.businessProperty==='undefined'?'':this.$route.query.businessProperty;
        this.onLoad();
    }
};
</script>
<style lang="scss" scoped>
.search-result {
    height: 100%;
    display: flex;
    flex-direction: column;

    .van-search {
        padding: 6px 0;

        .van-search-back {
            padding: 0 15px;
            width: 12px;
        }
        .van-search__action {
            padding: 0 13px;
        }
    }
    .van-hairline--top-bottom {
        transform: none;
    }
}
</style>